import React from "react";

export const TIME_FILTER = {
  TODAY: 1,
  YESTERDAY: 2,
  THIS_WEEK: 3,
  LAST_WEEK: 4,
  THIS_MONTH: 5,
  LAST_MONTH: 6,
  CUSTOM: 7,
};

export const hubColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    dataIndex: "name",
    // width: "140px",
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-black py-3 capitalize">
        {text}
      </div>
    ),
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Hub Manager
  //     </div>
  //   ),
  //   dataIndex: "hubManager",
  //   // width: "140px",
  //   sorter: (a, b) => a.hubManager.localeCompare(b.hubManager),
  //   render: (text) => (
  //     <div className="text-xs font-semibold font-aileron text-dark-gray">
  //       {text}
  //     </div>
  //   ),
  // },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Produced
      </div>
    ),
    dataIndex: "totalEnergyProduced",
    // width: "140px",
    sorter: (a, b) => a.totalEnergyProduced - b.totalEnergyProduced,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-dark-gray">
        {text ? `${text} KWh` : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Consumed
      </div>
    ),
    dataIndex: "totalEnergyConsumed",
    // width: "140px",
    sorter: (a, b) => a.totalEnergyConsumed - b.totalEnergyConsumed,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-dark-gray">
        {text ? `${text} KWh` : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Stored
      </div>
    ),
    dataIndex: "totalEnergyStored",
    // width: "140px",
    sorter: (a, b) => a.totalEnergyStored - b.totalEnergyStored,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-dark-gray">
        {text ? `${text} KWh` : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Energy Available
      </div>
    ),
    dataIndex: "totalBatteryCapacity",
    // width: "140px",
    sorter: (a, b) => a.totalBatteryCapacity - b.totalBatteryCapacity,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-dark-gray">
        {text} kWh
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Batteries Charged
      </div>
    ),
    dataIndex: "chargedBatteries",
    // width: "140px",
    sorter: (a, b) => a.chargedBatteries - b.chargedBatteries,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron text-dark-gray">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Upcoming Trips
      </div>
    ),
    dataIndex: "upcomingTrips",
    // width: "140px",
    sorter: (a, b) => a.upcomingTrips - b.upcomingTrips,
    render: (text) => (
      <div className="ml-1 h-5 px-[8.5px] flex items-center bg-green-10 rounded-md max-w-max">
        <p className="font-poppins text-xs font-medium text-green">{text}</p>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Upcoming Sessions
      </div>
    ),
    dataIndex: "upcomingSessions",
    // width: "140px",
    sorter: (a, b) => a.upcomingSessions - b.upcomingSessions,
    render: (text) => (
      <div className="ml-1 h-5 px-[8.5px] flex items-center bg-green-10 rounded-md max-w-max">
        <p className="font-poppins text-xs font-medium text-green">{text}</p>
      </div>
    ),
  },
];

export const ENERGY_DISTRIBUTION_CATEGORY = {
  CHARGING_STATION: 1,
  COLD_STORAGE: 2,
  FREEZER: 3,
  WORKING_STATION: 4,
};
